export default {
  text: 'Åbn {{paymentGateway}}-profil',
  text_generic: 'Åbn onboardingprofil',
  toasts: {
    failed_to_create: '{{paymentGateway}}-profilen kunne ikke åbnes',
    link_copied: 'Link kopieret til udklipsholderen',
    copy_failed: 'Linket kunne ikke kopieres',
  },
};
